import NotFoundComponent from 'src/components/common/404-not-found'

const Error404 = () => {
  return <NotFoundComponent></NotFoundComponent>
}

export default Error404
